
// Import module styles.
import "./merge.view.less";

// Define controllers.
window.zwdz6r = {
	FormController
};

function FormController() {

	return {
		// Public properties.
		isSubmitting: false,

		// Public methods.
		handleSubmit: handleSubmit
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I manage the form submission.
	*/
	function handleSubmit( event ) {

		if ( this.isSubmitting || ! confirm( "Are you sure you want to merge these two exercises?" ) ) {

			event.preventDefault();
			return;

		}

		this.isSubmitting = true;

	}

}
